import React, { useState } from 'react';
import axios from 'axios';
import './CSS/add_techno_news.css'; // optional styling

const AddNews = () => {
  const [header, setHeader] = useState('');
  const [paragraph, setParagraph] = useState('');
  const [image, setImage] = useState(null);
  const [responseMessage, setResponseMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('header', header);
    formData.append('paragraph', paragraph);
    if (image) formData.append('image', image);

    try {
      const res = await axios.post('https://weynibirhan.com.et/add_economics_news.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setResponseMessage(res.data.message);
      setHeader('');
      setParagraph('');
      setImage(null);
    } catch (err) {
      setResponseMessage('Error posting news.');
      console.error(err);
    }
  };

  return (
    <div className="add-news-container">
      <h2>Add Technology News</h2>
      <form onSubmit={handleSubmit} className="add-news-form">
        <input
          type="text"
          placeholder="Header"
          value={header}
          onChange={(e) => setHeader(e.target.value)}
          required
        />
        <textarea
          placeholder="Paragraph"
          value={paragraph}
          onChange={(e) => setParagraph(e.target.value)}
          required
        />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
        />
        <button type="submit">Post News</button>
      </form>
      {responseMessage && <p className="response-message">{responseMessage}</p>}
    </div>
  );
};

export default AddNews;
